import { FieldPath } from "react-hook-form";

import { useRateContext } from "../Context/RateContext";

import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

type RateFieldKey = keyof RateData;

type RateFieldPath<K extends RateFieldKey> = `rates.${number}.${K}` & FieldPath<StepTicketsFormData>;

export const useRateFieldName = <K extends RateFieldKey>(field: K): RateFieldPath<K> => {
  const { rateIndex } = useRateContext();
  return `rates.${rateIndex}.${field}` as RateFieldPath<K>;
};
